import React from 'react';

import { Typography } from '@mui/material';
import { ChevronLeft, ChevronRight, Square, SquareCheck } from 'lucide-react';
import { useEditorSuggestionState } from 'src/editor/editor-suggestion-state-registry';
import { makeStyles } from 'tss-react/mui';

import { getSelectedSuggestionUnitIndex } from './suggestion-navigation-helpers';
import { useSuggestionUnitNavigationHooks } from './useNavigationHooks';

const useStyles = makeStyles()(theme => ({
  chevronContainer: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(0.5),
  },
  container: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(1),
  },
  navigationButton: {
    '&:hover': {
      backgroundColor: '#FFE8D4',
    },
    alignItems: 'center',
    borderRadius: '100%',
    cursor: 'pointer',
    display: 'flex',
    padding: theme.spacing(0.5),
  },
  selectAllButton: {
    '&:hover': {
      backgroundColor: '#FFE8D4',
    },
    alignItems: 'center',
    borderRadius: 16,
    cursor: 'pointer',
    display: 'flex',
    gap: theme.spacing(1),
    height: 24,
    padding: theme.spacing(0, 1),
  },
}));

export function SuggestionsAlertNav(): JSX.Element {
  const { classes } = useStyles();
  const { handleAllAiEdits, selectedSuggestionGroupId, setHandleAllAiEdits, suggestionUnits } =
    useEditorSuggestionState();
  const { handleNavigateDown, handleNavigateUp } = useSuggestionUnitNavigationHooks();
  const selectedSuggestionUnitIndex = getSelectedSuggestionUnitIndex(
    suggestionUnits,
    selectedSuggestionGroupId
  );

  return (
    <div className={classes.container}>
      <div className={classes.chevronContainer}>
        <div className={classes.navigationButton} onClick={handleNavigateUp}>
          <ChevronLeft size={20} />
        </div>
        <div>
          <Typography noWrap>
            {selectedSuggestionUnitIndex + 1} of {suggestionUnits.length}
          </Typography>
        </div>
        <div className={classes.navigationButton} onClick={handleNavigateDown}>
          <ChevronRight size={20} />
        </div>
      </div>
      <div
        className={classes.selectAllButton}
        onClick={() => setHandleAllAiEdits(!handleAllAiEdits)}
      >
        {handleAllAiEdits ? <SquareCheck size={16} /> : <Square size={16} />}
        <Typography noWrap>Handle all</Typography>
      </div>
    </div>
  );
}
